import React__default from 'react';

var ArtworkBuilding = function ArtworkBuilding(props) {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    width: "72",
    height: "72",
    className: props === null || props === void 0 ? void 0 : props.className
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M6 63V9h30v12h30v42H6Zm6-6h18v-6H12v6Zm0-12h18v-6H12v6Zm0-12h18v-6H12v6Zm0-12h18v-6H12v6Zm24 36h24V27H36v30Zm6-18v-6h12v6H42Zm0 12v-6h12v6H42Z",
    fill: "#ECEDEF"
  }));
};

export { ArtworkBuilding, ArtworkBuilding as default };
//# sourceMappingURL=artwork-building.esm.js.map
